import { render, staticRenderFns } from "./contractChangeAuditHistoryOrdersList.vue?vue&type=template&id=8d4df048&scoped=true"
import script from "./contractChangeAuditHistoryOrdersList.vue?vue&type=script&lang=js"
export * from "./contractChangeAuditHistoryOrdersList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeAuditHistoryOrdersList.vue?vue&type=style&index=0&id=8d4df048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4df048",
  null
  
)

export default component.exports